import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Button, Icon, Label, Popup } from "semantic-ui-react";
import moment from "moment";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTire } from "@fortawesome/pro-light-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import AppService from "./../../modules/Appointments/service";
import { Can } from "../../modules";
import "./DBBButton.css";

class DBBButton extends Component {
  getDBBLink = () => {
    if (!this.props.onError) return;

    if (!this.props.appointment.id) return this.props.onError("No appointment ID provided");

    AppService.getDBBLink({ id: this.props.appointment.id })
      .then(result => {
        if (!result?.data?.data?.url) {
          this.props.onError("An unknown error occured, please try again");
        }

        let t = window.open(result.data.data.url, "_blank");
        t.focus();
      })
      .catch(error => {
        let errorMsg = error.response && error.response.data ? error.response.data.errors[0] : "Error getting DBB link";
        this.props.onError(errorMsg);
        console.warn("Error getting DBB link for car.", error);
      });
  };

  refreshDBB = () => {
    if (!this.props.onError) return;

    if (!this.props.appointment.id) return this.props.onError("No appointment ID provided");

    AppService.refreshDBB({ id: this.props.appointment.id })
      .then(result => {
        if (!result || !result.data || !result.data.data) {
          this.props.onError("An unknown error occured, please try again");
        }

        this.props.onCarUpdate(result.data.data);
      })
      .catch(error => {
        let errorMsg = error.response && error.response.data ? error.response.data.errors[0] : "Error refreshing DBB";
        this.props.onError(errorMsg);
        console.warn("Error refreshing DBB", error);
      });
  };

  handlePortalClick = () => {
    this.getDBBLink();
  };

  handleRefreshClick = () => {
    this.refreshDBB();
  };

  render() {
    let { appointment, t } = this.props;
    let status = "no-dbb";
    let icon = false;
    let iconColor = null;
    let popupText = null;

    let hasFinalCarCheckDBBStatus = appointment.final_car_check_dbb_status > 0;
    let dbbStatus = hasFinalCarCheckDBBStatus ? appointment.final_car_check_dbb_status : appointment.car_check_dbb_status;
    let dbbStatusReason = hasFinalCarCheckDBBStatus ? appointment.final_car_check_dbb_status_reason : appointment.car_check_dbb_status_reason;

    if (appointment.car.has_dbb) {
      if (appointment.car.dbb_appointment_date) {
        if (moment().isAfter(appointment.car.dbb_appointment_date)) {
          status = "valid-appointment";
        } else {
          status = "waiting-appointment";
        }

        if (dbbStatus > 0) {
          icon = true;
          iconColor = dbbStatus === 1 ? "green" : dbbStatus === 2 ? "orange" : "red";

          if (dbbStatus === 2) {
            popupText = {
              bold: dbbStatusReason || t("miniportal_approval").message || "Miniportal is pending your approval,",
              normal: t("for_issues_reach_dbb_support").message || "for issues please reach out to DBB Support.",
            };
          } else if (dbbStatus === 3) {
            popupText = {
              bold: dbbStatusReason || t("unexpected_error").message || "An unexpected error has occurred,",
              normal: t("for_issues_reach_us").message || "for issues please reach out to us.",
            };
          }
        }
      } else {
        status = "no-appointment";
      }
    }

    return (
      <Can I="update" the="dbb">
        <Button.Group basic fluid className="DBBButton">
          <Popup
            hoverable
            wide
            disabled={!popupText}
            content={
              popupText && (
                <div className="DBBButton-popup">
                  <strong>{popupText.bold}</strong> {popupText.normal}
                </div>
              )
            }
            trigger={
              <Button basic size="large" className={`-status-${status}`} onClick={this.handlePortalClick}>
                {icon && (
                  <Label className="checkedTire" circular color={iconColor}>
                    <FontAwesomeIcon className="checkedTire-tire" icon={faTire} />
                    <FontAwesomeIcon className="checkedTire-check" icon={faCheck} />
                  </Label>
                )}

                <div className="button_text">
                  <div>DBB</div>
                  {status !== "no-dbb" && status !== "no-appointment" && (
                    <div className="button_app_date">{moment(appointment.car.dbb_appointment_date).format("DD-MM-YYYY")}</div>
                  )}
                </div>
              </Button>
            }
          />

          <Button basic icon onClick={this.handleRefreshClick}>
            <Icon name="refresh" />
          </Button>
        </Button.Group>
      </Can>
    );
  }
}

export default withTranslation()(DBBButton);
